import { computed, inject, Injectable, resource } from '@angular/core';

import { AdminModeService } from '../../../../auth/admin-mode/admin-mode.service';
import { RetailCrmService } from './retail-crm.service';

@Injectable({
  providedIn: 'root',
})
export class LegalEntitiesService {
  private readonly adminModeService = inject(AdminModeService);
  private readonly retailCrmService = inject(RetailCrmService);

  private readonly relatedDealersResource = resource({
    // Load again if the active admin dpNr changes
    params: () => this.adminModeService.activeAdminDpNr() ?? true,

    loader: async () => {
      try {
        return await this.retailCrmService.getRelatedDealers();
      } catch (_) {
        return [];
      }
    },
  });

  public readonly sortedRelatedDealers = computed(() => {
    return this.relatedDealersResource
      .value()
      ?.sort((a, b) => a.distributionPartnerNr.localeCompare(b.distributionPartnerNr));
  });
}
